export const FETCH_USERS_REQUEST='FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS='FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE='FETCH_USERS_FAILURE';

export const FETCH_PROFILE_REQUEST='FETCH_PROFILE_REQUEST';
export const FETCH_PROFILE_SUCCESS='FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE='FETCH_PROFILE_FAILURE';

